export default __webpack_public_path__ + "static/media/c4.8dd77a52.svg";